import LabelModal from './LabelModal';

export default (props) => {
  return <LabelModal {...props} />;
};
